<template>
    <v-card flat tile  :outlined="isDesktop" :class="{'py-3': !isDesktop}">
        <v-list-item>
            <v-list-item-avatar color="blue white--text" size=32 @click="$router.push(`/${post.user.username}`)">
                <img v-if="post.user.avatar_url" :src="post.user.avatar_url" :alt="post.user.name">
                <span v-else>{{post.user.name[0]}}</span>
            </v-list-item-avatar>
            <v-list-item-content @click="$router.push(`/${post.user.username}`)">
                <v-list-item-title class="body-2 mb-0" v-html="post.user.name"></v-list-item-title>
                <v-list-item-subtitle class="caption" v-if="post.user.role">
                    {{ post.user.role }}
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
                <social-sharing :url="`https://arclif.com/post/${post.id}/`"
                :title="post.title"
                :image="post.attachments.length ? post.attachments[0].file_url : ''"
                inline-template>
                    <div class="d-flex">
                        <network network="whatsapp">
                            <i aria-hidden="true" class="v-icon notranslate mdi mdi-whatsapp theme--light"></i>
                        </network>
                        <network network="facebook" class="ml-2">
                            <i aria-hidden="true" class="v-icon notranslate mdi mdi-facebook theme--light"></i>
                        </network>
                    </div>
                </social-sharing>

            </v-list-item-action>
        </v-list-item>
        <v-card v-if="post.attachments.length" tile flat color="grey" :to="`/post/${post.id}/`">

            <v-img :src="post.attachments[0].file_url" 
            gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0, 0.2) 20%, transparent"
            class="white--text align-end" 
            eager
            :lazy-src="post.attachments[0].thumbnail_file_url">
                <v-btn text absolute right top class="white--text">1 / {{post.attachments_count}}</v-btn>
                <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                </template>
            </v-img>
        </v-card>
        <div class="px-4 pt-4">
            <p class="caption mb-0 grey--text"><Timeago :datetime="post.created_at" :auto-update="60"></Timeago></p>
            <router-link :to="`/post/${post.id}`" tag="span">
                <h3 class="title" v-if="post.title">{{post.title}}</h3>
            </router-link>
            <text-description v-if="post.description" :description="post.description"></text-description>
        </div>
        <v-card-actions>
            <bar-post-actions class="mx-0" :post="post"
            :likesLink="!isDesktop ? `/post/${post.id}/likes/` : ''"
            @likesClick="onlikesClick"></bar-post-actions>
        </v-card-actions>
    </v-card>
</template>
<script>
import mixinPost from "@/mixins/mixin-post"
import barPostActions from "@/components/bars/bar-post-actions.vue"
export default {
    mixins: [mixinPost],

    props: {
        post: Object
    },

    components: {
        'bar-post-actions': barPostActions
    },

    data: () => ({

    }),

    methods: {
        onlikesClick() {
            this.$emit('likesClick', this.post.id)
        }
    }
}
</script>